import {
  AlignJustifyIcon,
  BookOpenIcon,
  ClockIcon,
  FileTextIcon,
  FilesIcon,
  ImageIcon,
  LinkIcon,
  PlayIcon,
  TabletSmartphoneIcon,
  Volume2Icon
} from 'lucide-react'

export const COURSE_ICONS = [
  { name: 'link', icon: <LinkIcon /> },
  { name: 'play', icon: <PlayIcon /> },
  { name: 'book-open', icon: <BookOpenIcon /> },
  { name: 'document-text', icon: <FileTextIcon /> },
  { name: 'menu-alt-2', icon: <AlignJustifyIcon /> },
  { name: 'device-mobile-icon', icon: <TabletSmartphoneIcon /> },
  { name: 'photograph-icon', icon: <ImageIcon /> },
  { name: 'document-duplicate', icon: <FilesIcon /> },
  { name: 'clock', icon: <ClockIcon /> },
  { name: 'volume-up', icon: <Volume2Icon /> }
]
